import { render } from "./userMinors.vue?vue&type=template&id=5f35c3a6&scoped=true"
const script = {}

import "./userMinors.vue?vue&type=style&index=0&id=5f35c3a6&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f35c3a6"]])

export default __exports__